import React, { useEffect, useState } from 'react'
import { changeRole, getAllUsers } from '../../API/auth'

function ManageUsers() {
    const [data, setData] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        getAllUsers()
            .then(data => setData(data))
    }, [reload])

    const makeInstructor = (id) => {
        changeRole(id, "instructor")
            .then(data => {
                if (data.modifiedCount === 1) {
                    setReload(!reload)
                }
            })
    }

    const makeAdmin = (id) => {
        changeRole(id, "admin")
            .then(data => {
                if (data.modifiedCount === 1) {
                    setReload(!reload)
                }
            })
    }

    return (
        <>
            <p className='text-center font-bold text-5xl tracking-tight pt-10 font-serif dark:text-white'>All Users</p>
            <div className='max-w-[85%] mx-auto mt-8 pb-16'>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-center text-gray-700 uppercase bg-green-100 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="py-3">
                                    No.
                                </th>
                                <th scope="col" className="py-3 ps-3 text-left">
                                    Photo
                                </th>
                                <th scope="col" className="py-3 text-left">
                                    Username
                                </th>
                                <th scope="col" className="py-3">
                                    Email
                                </th>
                                <th scope="col" className="py-3">
                                    Role
                                </th>
                                <th scope="col" className="py-3">
                                    Make Instructor
                                </th>
                                <th scope="col" className="py-3">
                                    Make Admin
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((d, i) =>
                                    <tr key={d._id} className="bg-white text-center border-b dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td className="p-4">
                                            <div className="flex ps-2 items-center">
                                                {i + 1}
                                            </div>
                                        </td>
                                        <th scope="row" className="py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {console.log(d.photo)}
                                            <img className='w-16 rounded-full' src={d.photo} alt="" />
                                        </th>
                                        <th scope="row" className="py-4 font-medium text-gray-900 text-left whitespace-nowrap dark:text-white">
                                            {d.name}
                                        </th>
                                        <td className="py-4">
                                            {d.email}
                                        </td>
                                        <td className="py-4 capitalize">
                                            {d.role}
                                        </td>
                                        <td className="py-4">
                                            <div className='flex items-center justify-center space-x-4'>
                                                <button onClick={() => makeInstructor(d._id)} type="button" className={`text-white bg-emerald-500 ${d.role === "admin" || d.role === "instructor" ? "cursor-not-allowed" : "hover:bg-emerald-600"}  focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center`} disabled={d.role === "instructor" || d.role === "admin"}>Promote</button>
                                            </div>
                                        </td>
                                        <td className="py-4">
                                            <button onClick={() => makeAdmin(d._id)} type="button" className={`text-white bg-emerald-500 ${d.role === "admin" ? "cursor-not-allowed" : "hover:bg-emerald-600"}  focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center`} disabled={d.role === "admin"}>Confirm</button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ManageUsers